import React from "react";
import ViewImportHistoryTable from "../../recommendations/components/ViewImportHistoryTable";
import BuildModalHeader from "../../common/components/BuildModalHeader";

const ExportedFiles = ({ projectId, onCancel, clientId, masterFilter = {} }) => {
    return (
        <div
            class="modal assign-init-modal image-pull-modal img-logs"
            style={{ display: "block" }}
            id="modalId"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog assignModal" role="document">
                <div class="modal-content">
                    <BuildModalHeader title="Exported Files" onCancel={onCancel} modalClass="assignModal" />
                    <form autoComplete="nope">
                        <div className="modal-body ">
                            <div className="form-group">
                                <div className="formInp">
                                    <div className="dashboard-outer">
                                        <div className="outer-detail">
                                            <div className="right-panel-section">
                                                <div className="dtl-sec">
                                                    <div className="dtl-sec system-building col-md-12 ">
                                                        <div className="tab-dtl region-mng">
                                                            <div className="tab-active recomdn-table bg-grey-table">
                                                                <div className={`dtl-sec `}>
                                                                    <div className="table-top-menu allign-right">
                                                                        <div className="rgt">
                                                                            <ViewImportHistoryTable
                                                                                clientId={clientId}
                                                                                projectId={projectId}
                                                                                source="files"
                                                                                masterFilter={masterFilter}
                                                                                isModal={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ExportedFiles;
